module.exports = __webpack_public_path__ + "78d55f3926a71569cbb424a4cd3a1426.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-10.png
// module id = 2213
// module chunks = 0